import React from "react";
//import forward from "../../assets/onboarding/forward.svg";
import Loader from "../Util/Loader";

const PrimaryButton = ({
  onClick,
  text,
  disabled,
  type,
  variant,
  isLoading,
  width,
  borderRadius,
  className,
}) => {
  const style = {
    ...(width && { width }), 
    ...(borderRadius && { borderRadius }), 
  };
  return variant === "full" ? (
    <button
      className={`bg-[#FFAE00] text-[#FFF] w-full h-[3.25rem] px-6 py-[16px] flex justify-center items-center text-[1rem] font-satoshi-bold rounded-[0.95rem] disabled:bg-[#EAEAEC] disabled:text-[#BFC1C6] ${className}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      style={style}

    >
      {isLoading ? (
        <div>
          <Loader loading={isLoading} />
        </div>
      ) : (
        <p>{text}</p>
      )}
    </button>
  ) : variant === "tag" ? (
    <button
      className={`w-20 h-10 bg-[#FFAE00] flex items-center justify-center rounded-[4.1875rem] gap-2 cursor-pointer text-sm text-[#FFF] font-satoshi-bold disabled:cursor-not-allowed ${className}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      style={style}
    >
      {text}
    </button>
  ) : variant === "small" ? (
    <button
    className={`bg-[#FFAE00] text-[#FFF] h-[2.625rem] w-[9.125rem] flex justify-center items-center text-[0.875rem] font-satoshi-bold rounded-[1rem] disabled:bg-[#EAEAEC] disabled:text-[#BFC1C6] ${className}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      style={style}
    >
      {isLoading ? (
        <div className="h-full w-full p-4">
          <Loader loading={isLoading} />
        </div>
      ) : (
        <p>{text}</p>
      )}
    </button>
  ) : (
    <button
      className={`bg-[#FFAE00] text-[#FFF] w-max max-w-[15rem] h-[3.25rem] px-6 py-[16px] flex justify-center items-center text-[1rem] font-satoshi-bold rounded-[0.95rem] disabled:bg-[#EAEAEC] disabled:text-[#BFC1C6] ${className}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
      style={style}
    >
      {isLoading ? (
        <div className="h-full w-full p-4">
          <Loader loading={isLoading} />
        </div>
      ) : (
        <p>{text}</p>
      )}
    </button>
  );
};

export default PrimaryButton;
